import { AHText, AHTextFonts, Box, Circle, AHIcon } from "arkh";
import React from "react";
import { View } from "react-native";
import { graphql, useFragment } from "react-relay";
import { formatValue } from "arkh/common";
import { NumberText } from "./NumberText";
import { FillingText } from "./FillingText";
import { KPIItemTeamInProgress_RoutineOccasion$key } from "./__generated__/KPIItemTeamInProgress_RoutineOccasion.graphql";

export const KPIItemInProgress = (props: {
  inProgress: KPIItemTeamInProgress_RoutineOccasion$key;
  freq?: "DAILY" | "WEEKLY" | "MONTHLY" | "YEARLY";
}) => {
  const inProgress = useFragment(
    graphql`
      fragment KPIItemTeamInProgress_RoutineOccasion on RoutineOccasion {
        id
        startAt

        occasionSections(teamId: $teamId) {
          taskExecutions {
            ... on TaskExecutionNumber {
              formattedNumberValue
              numberValue
              isCompleted
              task {
                ... on TaskNumber {
                  unit
                }
              }
            }
          }
        }
      }
    `,
    props.inProgress
  );

  if (!inProgress || inProgress.occasionSections.length === 0) {
    return null;
  }

  if (inProgress.occasionSections.length === 1) {
    if (
      inProgress.occasionSections[0]?.taskExecutions.some(
        (te) => !te.isCompleted
      )
    ) {
      return (
        <Box
          style={{
            flex: 1,
            justifyContent: "flex-end",
          }}
        >
          <Box spaceBottom="xsmall">
            <FillingText startAt={inProgress.startAt} freq={props.freq} />
          </Box>
          <Circle color="primary" size="small">
            <AHIcon type="arrow-right" customColor="#FFF" forceSize={14} />
          </Circle>
        </Box>
      );
    }
    return (
      <Box style={{ flex: 1, justifyContent: "flex-end" }}>
        <FillingText filled startAt={inProgress.startAt} freq={props.freq} />
        <NumberText>
          {inProgress.occasionSections[0]?.taskExecutions[0]
            ?.formattedNumberValue ?? ""}
        </NumberText>
      </Box>
    );
  }

  const total = inProgress.occasionSections.reduce(
    (prev, curr) => prev + (curr.taskExecutions[0].numberValue ?? 0),
    0
  );

  const unit =
    inProgress.occasionSections[0]?.taskExecutions[0]?.task?.unit ?? "CUSTOM";

  const answered = inProgress.occasionSections.filter(
    (os) => os.taskExecutions[0].isCompleted
  );

  const [format, u] = formatValue(unit, total);

  const hasAnswered = answered.length === inProgress.occasionSections.length;
  return (
    <View
      style={{
        alignItems: "flex-end",
        flexDirection: "row",
        flex: 1,
      }}
    >
      {hasAnswered ? (
        <Box>
          <AHText numberOfLines={1} type="detail">
            {`snitt ${format(
              Math.round(total / inProgress.occasionSections.length)
            )} ${u ? u : ""}`}
          </AHText>
          <NumberText>{`${format(total)} ${u ? u : ""}`}</NumberText>
        </Box>
      ) : (
        <Box>
          <FillingText startAt={inProgress.startAt} freq={props.freq} />
          <Box spaceTop="xsmall" />
          <Box
            space="xxsmall"
            spaceHorizontal="xsmall"
            cornerRadius="large"
            style={{
              flexDirection: "row",
              alignSelf: "flex-start",
              alignItems: "center",
            }}
            color="primary"
          >
            <AHText
              font={AHTextFonts.BOLD}
              size={9}
              spaceRight="small"
              color="lightText"
            >
              {answered.length} / {inProgress.occasionSections.length}
            </AHText>
            <AHIcon type="arrow-right" customColor="#FFF" forceSize={14} />
          </Box>
        </Box>
      )}
    </View>
  );
};
